import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { tokens } from '../theme.js';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <Box component="footer" sx={{ bgcolor: tokens.cream, color: 'text.secondary', borderTop: `1px solid ${tokens.line}` }}>
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 3, py: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/logo_removebg.png`}
          alt={t('footer.logoAlt')}
          sx={{ width: { xs: 250, sm: 310 }, maxWidth: '100%', height: 'auto' }}
        />
        <Box sx={{ display: 'flex', gap: 2.5, alignItems: 'center', flexWrap: 'wrap' }}>
          <Link href="#solutions" underline="hover" sx={{ color: 'inherit', fontSize: '0.8rem' }}>{t('nav.solutions')}</Link>
          <Link href="#institutions" underline="hover" sx={{ color: 'inherit', fontSize: '0.8rem' }}>{t('nav.institutions')}</Link>
          <Typography sx={{ fontSize: '0.8rem' }}>{t('footer.copyright', { year: new Date().getFullYear() })}</Typography>
        </Box>
      </Container>
    </Box>
  );
}
